/* eslint-disable max-len */
function LinkSvg(props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> {
    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_38017_7286" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_38017_7286)">
            <path d="M5.79923 7.83749L3.62752 10.0092C2.45252 11.1842 2.46537 13.1021 3.6562 14.2929C4.84704 15.4838 6.76493 15.4966 7.93993 14.3216L10.1116 12.1499" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.4932 7.45703L7.39113 10.5591" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.83846 5.79923L10.0102 3.62752C11.1852 2.45252 13.1031 2.46537 14.2939 3.6562C15.4847 4.84704 15.4976 6.76493 14.3226 7.93993L12.1509 10.1116" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>;
}

export default LinkSvg;
